import axios from "axios";

// ── Legacy / Old API base (external service) ──────────────────────────────────
const baseApi = 'https://www.wheelbackend.wheel2fortune.com';
 
// ── New Spin-Game Backend (local Spring Boot) ─────────────────────────────────
// const baseApi = 'http://192.168.1.13:8080';
// const baseApi = 'http://88.99.5.236:9873';
// 9873
 
// ──────────────────────────────────────────────────────────────────────────────
// Legacy API functions (kept as-is, used by Index.js, Otp.js, etc.)
// ──────────────────────────────────────────────────────────────────────────────
 
// export const Checkuser = async (ani) => {
//   const parameter = { ani };
//   console.log("Checkuser param:", parameter);
//   return await axios.post(baseApi + "/check?ani=", parameter);
// };
export const Checkuser = async (ani) => {
  console.log("check-access ani:", ani);
  return await axios.get(baseApi + "/api/v1/check-access", { params: { ani } });
};
 
export const Gameinfo = async () => {
  return await axios.get(baseApi + "/gameInfo");
};
 
export const Checkscore = async (ani, gameId) => {
  const param = { ani, gameId };
  return await axios.post(baseApi + "/checkPoint", param);
};
 
export const Leader = async () => {
  return await axios.get(baseApi + "/leader");
};
 
export const GifApi = async () => {
  return await axios.get(baseApi + "/gif");
};
 
export const CheckScoreForScorePage = async (ani) => {
  const parameter = { ani };
  return await axios.post(baseApi + "/score", parameter);
};
 
export const RedeemApi = async (ani) => {
  const parameter = { ani };
  return await axios.post(baseApi + "redeem", parameter);
};
 
// export const EditName = async (ani, name, imageName) => {
//   const parameter = { ani, name, image: imageName };
//   return await axios.post(baseApi + "editName", parameter);
// };

export const EditName = async (msisdn, profileName,profileUrl) => {
  const parameter = { msisdn, profileName,profileUrl };
  return await axios.put(baseApi + "/api/spin/update-profile", parameter);
};
 
// ──────────────────────────────────────────────────────────────────────────────
// New Spin-Game API functions (Spring Boot backend at localhost:8080)
// ──────────────────────────────────────────────────────────────────────────────
 
/**
 * Check if a user is eligible to spin today.
 * Returns: { canPlay, isFreeSpin, message, requiredPoints, currentPoints, nextFreeSpinSeconds }
 */
export const checkEligibility = async (msisdn) => {
  const response = await axios.get(`${baseApi}/api/spin/eligibility`, {
    params: { msisdn },
  });
  return response.data;
};

/**
 * Play the spin. Deducts 50 points, determines reward, saves history.
 * Returns: { success, rewardType, rewardPoints, wheelIndex, totalPoints, message, newlyUnlockedAchievements }
 */
export const playSpin = async (msisdn) => {
  const response = await axios.post(`${baseApi}/api/spin/play`, null, {
    params: { msisdn },
  });
  return response.data;
};
 
/**
 * Fetch last 10 spin history records for a user.
 * Returns: Array of { rewardType, rewardPoints, spinTime }
 */
export const getSpinHistory = async (msisdn) => {
  const response = await axios.get(`${baseApi}/api/spin/history`, {
    params: { msisdn },
  });
  return response.data;
};
 
/**
 * Fetch full user profile and stats.
 * Returns: { totalPoints, totalSpins, totalWins, lastReward, currentStreak, longestStreak, nextFreeSpinSeconds, achievements }
 */
export const getUserProfile = async (msisdn) => {
  const response = await axios.get(`${baseApi}/api/spin/profile`, {
    params: { msisdn },
  });
  return response.data;
};


export const getGames = async () => {
  const response = await axios.get(`${baseApi}/api/v1/games`);
  return response.data;
};

export const getHistory = async (msisdn) => {
  const response = await axios.get(`${baseApi}/api/spin/history`, {
    params: { msisdn },
  });
  return response.data;
};



